/* ═══════════════════════════════════════
   OBJEXYZ THEME — MAIN JS v2.3
   ═══════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── MOBILE MENU ─── */
  const hamburger    = document.getElementById('hamburger');
  const mobileMenu   = document.getElementById('mobileMenu');
  const mobileOverlay = document.getElementById('mobileOverlay');
  const mobileClose  = document.getElementById('mobileClose');

  function openMobileMenu() { mobileMenu?.classList.add('open'); mobileOverlay?.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeMobileMenu() { mobileMenu?.classList.remove('open'); mobileOverlay?.classList.remove('open'); document.body.style.overflow = ''; }

  hamburger?.addEventListener('click', openMobileMenu);
  mobileClose?.addEventListener('click', closeMobileMenu);
  mobileOverlay?.addEventListener('click', closeMobileMenu);


  /* ─── CART DRAWER ─── */
  const cartTrigger   = document.getElementById('cartTrigger');
  const cartClose     = document.getElementById('cartClose');
  const cartOverlay   = document.getElementById('cartOverlay');
  const cartDrawer    = document.getElementById('cartDrawer');
  const cartBadge     = document.getElementById('cartBadge');
  const cartItemCount = document.getElementById('cartItemCount');
  const cartItems     = document.getElementById('cartItems');
  const cartEmpty     = document.getElementById('cartEmpty');
  const cartFooter    = document.getElementById('cartFooter');
  const cartSubtotal  = document.getElementById('cartSubtotal');

  function openCart()  { cartDrawer?.classList.add('open'); cartOverlay?.classList.add('open'); document.body.style.overflow = 'hidden'; fetchCart(); }
  function closeCart() { cartDrawer?.classList.remove('open'); cartOverlay?.classList.remove('open'); document.body.style.overflow = ''; }

  cartTrigger?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  function formatMoney(cents) {
    return 'PKR\u00a0' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 2 });
  }

  function broadcastCart(cart){
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function updateCartBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    cartBadge.style.display = count > 0 ? 'flex' : 'none';
    if (cartItemCount) cartItemCount.textContent = count > 0 ? count : '';
  }

  function renderCart(cart) {
    broadcastCart(cart);
    if (!cartItems) return;
    updateCartBadge(cart.item_count);
    if (cart.item_count === 0) {
      if (cartEmpty) cartEmpty.style.display = 'block';
      cartItems.innerHTML = '';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }
    if (cartEmpty) cartEmpty.style.display = 'none';
    if (cartFooter) cartFooter.style.display = 'block';
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    cartItems.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item-img" src="${item.image ? item.image.replace('_grande','_medium') : ''}" alt="${item.title}" onerror="this.style.display='none'">
        <div>
          <div class="cart-item-name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="cart-item-qty">
            <button class="qty-minus-cart" data-key="${item.key}" data-qty="${item.quantity - 1}">\u2212</button>
            <span>${item.quantity}</span>
            <button class="qty-plus-cart" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
          </div>
        </div>
        <div>
          <div class="cart-item-price">${formatMoney(item.line_price)}</div>
          <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove">\u2715</button>
        </div>
      </div>
    `).join('');
    cartItems.querySelectorAll('.qty-minus-cart,.qty-plus-cart').forEach(btn => {
      btn.addEventListener('click', function () { const qty = parseInt(this.dataset.qty); if (qty < 0) return; updateCartItem(this.dataset.key, qty); });
    });
    cartItems.querySelectorAll('.cart-item-remove').forEach(btn => {
      btn.addEventListener('click', function () { updateCartItem(this.dataset.key, 0); });
    });
  }

  function fetchCart() { fetch('/cart.js').then(r => r.json()).then(renderCart).catch(console.error); }
  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) })
      .then(r => r.json()).then(renderCart).catch(console.error);
  }

  function initAtcForms() {
    document.querySelectorAll('.atc-form').forEach(form => {
      if (form.dataset.init) return;
      form.dataset.init = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const btn = this.querySelector('.atc-btn');
        const orig = btn ? btn.textContent : '';
        if (btn) { btn.textContent = '...'; btn.disabled = true; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: this.querySelector('[name="id"]').value, quantity: 1 }) })
          .then(r => r.json())
          .then(() => { if (btn) { btn.textContent = '\u2713'; btn.disabled = false; } fetchCart(); setTimeout(openCart, 300); setTimeout(() => { if (btn) btn.textContent = orig; }, 2000); })
          .catch(() => { if (btn) { btn.textContent = 'Error'; btn.disabled = false; } setTimeout(() => { if (btn) btn.textContent = orig; }, 2000); });
      });
    });
  }
  initAtcForms();
  fetch('/cart.js').then(r => r.json()).then(c => { updateCartBadge(c.item_count); broadcastCart(c); }).catch(() => {});


  /* ─── HERO SLIDER ─── */
  const heroSlider = document.getElementById('heroSlider');
  if (heroSlider) {
    const slides   = Array.from(heroSlider.querySelectorAll('.hero-slide'));
    const dotsWrap = document.getElementById('heroDots');
    const prevBtn  = document.getElementById('heroPrev');
    const nextBtn  = document.getElementById('heroNext');
    const progress = document.getElementById('heroProgress');
    const total    = slides.length;
    if (total > 1) {
      if (dotsWrap) {
        dotsWrap.innerHTML = slides.map((_, i) =>
          `<button class="hero-dot${i === 0 ? ' active' : ''}" data-slide="${i}" aria-label="Slide ${i + 1}"></button>`
        ).join('');
      }
      const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.hero-dot')) : [];
      let current = 0, timer = null;
      const INTERVAL = 5000;
      function showSlide(n) {
        slides[current].classList.remove('active'); dots[current]?.classList.remove('active');
        current = ((n % total) + total) % total;
        slides[current].classList.add('active'); dots[current]?.classList.add('active');
        if (progress) { progress.style.transition = 'none'; progress.style.width = '0%'; requestAnimationFrame(() => requestAnimationFrame(() => { progress.style.transition = `width ${INTERVAL}ms linear`; progress.style.width = '100%'; })); }
      }
      function startAutoplay() { clearInterval(timer); timer = setInterval(() => showSlide(current + 1), INTERVAL); }
      if (progress) { progress.style.transition = 'none'; progress.style.width = '0%'; requestAnimationFrame(() => requestAnimationFrame(() => { progress.style.transition = `width ${INTERVAL}ms linear`; progress.style.width = '100%'; })); }
      prevBtn?.addEventListener('click', () => { showSlide(current - 1); startAutoplay(); });
      nextBtn?.addEventListener('click', () => { showSlide(current + 1); startAutoplay(); });
      dots.forEach(dot => dot.addEventListener('click', function () { showSlide(parseInt(this.dataset.slide)); startAutoplay(); }));
      let touchX = 0;
      heroSlider.addEventListener('touchstart', e => { touchX = e.changedTouches[0].clientX; }, { passive: true });
      heroSlider.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - touchX; if (Math.abs(dx) > 50) { showSlide(current + (dx < 0 ? 1 : -1)); startAutoplay(); } });
      startAutoplay();
    } else {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      if (dotsWrap) dotsWrap.style.display = 'none';
    }
  }


  /* ─── PRODUCT GALLERY & LIGHTBOX ─── */
  const mainImg = document.getElementById('mainImg');
  const thumbs  = document.querySelectorAll('.thumb');
  const galleryImgsEl = document.getElementById('galleryImages');
  let galleryData = [];
  if (galleryImgsEl) galleryData = Array.from(galleryImgsEl.children).map(el => ({ full: el.dataset.full, alt: el.dataset.alt || '' }));
  if (galleryData.length === 0 && mainImg) galleryData = [{ full: mainImg.src, alt: mainImg.alt || '' }];
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active')); this.classList.add('active');
      if (mainImg) { mainImg.src = this.dataset.src; mainImg.alt = this.dataset.alt || ''; mainImg.dataset.index = this.dataset.index; }
    });
  });
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightboxImg');
  const lightboxOverlay = document.getElementById('lightboxOverlay');
  const lightboxClose = document.getElementById('lightboxClose');
  const lightboxPrev = document.getElementById('lightboxPrev');
  const lightboxNext = document.getElementById('lightboxNext');
  const lightboxCounter = document.getElementById('lightboxCounter');
  let lbIdx = 0;
  function openLightbox(i) { if (!lightbox || !galleryData.length) return; lbIdx = ((i % galleryData.length) + galleryData.length) % galleryData.length; showLbImg(lbIdx); lightbox.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeLightbox() { lightbox?.classList.remove('open'); document.body.style.overflow = ''; }
  function showLbImg(i) { lbIdx = ((i % galleryData.length) + galleryData.length) % galleryData.length; if (lightboxImg) { lightboxImg.src = galleryData[lbIdx].full; lightboxImg.alt = galleryData[lbIdx].alt; } if (lightboxCounter) lightboxCounter.textContent = `${lbIdx + 1} / ${galleryData.length}`; const multi = galleryData.length > 1; if (lightboxPrev) lightboxPrev.style.display = multi ? 'flex' : 'none'; if (lightboxNext) lightboxNext.style.display = multi ? 'flex' : 'none'; }
  lightboxClose?.addEventListener('click', closeLightbox);
  lightboxOverlay?.addEventListener('click', closeLightbox);
  lightboxPrev?.addEventListener('click', () => showLbImg(lbIdx - 1));
  lightboxNext?.addEventListener('click', () => showLbImg(lbIdx + 1));
  const galleryZoom = document.getElementById('galleryZoom');
  const mainImgWrap = document.getElementById('mainImgWrap');
  galleryZoom?.addEventListener('click', e => { e.stopPropagation(); openLightbox(mainImg ? parseInt(mainImg.dataset.index || 0) : 0); });
  mainImgWrap?.addEventListener('click', function (e) { if (galleryZoom?.contains(e.target)) return; openLightbox(mainImg ? parseInt(mainImg.dataset.index || 0) : 0); });
  document.addEventListener('keydown', e => { if (!lightbox?.classList.contains('open')) return; if (e.key === 'Escape') closeLightbox(); if (e.key === 'ArrowLeft') showLbImg(lbIdx - 1); if (e.key === 'ArrowRight') showLbImg(lbIdx + 1); });


  /* ─── VARIANT SELECTOR ─── */
  const variantId   = document.getElementById('variantId');
  const priceMain   = document.getElementById('priceMain');
  const stickyPrice = document.getElementById('stickyPrice');
  const variants    = window.productVariants || [];

  function getSelectedOptions() {
    const opts = {};
    document.querySelectorAll('.option-values input[type="radio"]:checked').forEach(input => {
      opts[input.name.replace('options[','').replace(']','')] = input.value;
    });
    return opts;
  }
  function findVariant(opts) {
    return variants.find(v => v.options.every((o, i) => o === opts[Object.keys(opts)[i]]));
  }
  function fmtShopify(cents) {
    return 'PKR\u00a0' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 2 });
  }

  function applyVariantState(matched) {
    if (!matched) return;
    if (variantId) variantId.value = matched.id;

    const isCustomSize = matched.options.some(o => o === 'Custom Size (Larger)');
    const addBtn    = document.getElementById('addToCartBtn');
    const quoteBtn  = document.getElementById('requestQuoteBtn');
    const priceQuote = document.getElementById('priceQuote');
    const qtyGroup  = document.querySelector('.qty-group');

    if (isCustomSize) {
      if (addBtn)    { addBtn.style.display = 'none'; addBtn.disabled = true; }
      if (quoteBtn)  quoteBtn.style.display = 'flex';
      if (priceMain) priceMain.style.display = 'none';
      if (priceQuote) priceQuote.style.display = 'inline';
      if (stickyPrice) stickyPrice.textContent = 'REQUEST A QUOTE';
      if (qtyGroup)  qtyGroup.style.display = 'none';
    } else {
      if (addBtn)    { addBtn.style.display = ''; addBtn.disabled = !matched.available; addBtn.textContent = matched.available ? 'ADD TO CART' : 'OUT OF STOCK'; }
      if (quoteBtn)  quoteBtn.style.display = 'none';
      if (priceMain) { priceMain.style.display = ''; const p = fmtShopify(matched.price); priceMain.textContent = p; if (stickyPrice) stickyPrice.textContent = p; }
      if (priceQuote) priceQuote.style.display = 'none';
      if (qtyGroup)  qtyGroup.style.display = '';
    }
  }

  document.querySelectorAll('.option-values').forEach(group => {
    group.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', function () {
        const parent = this.closest('.option-group');
        parent?.querySelectorAll('.option-btn').forEach(b => b.classList.remove('active'));
        this.closest('.option-btn')?.classList.add('active');
        const idx = Array.from(document.querySelectorAll('.option-group')).indexOf(parent) + 1;
        const lbl = document.getElementById('optionSelected' + idx);
        if (lbl) lbl.textContent = this.value;
        applyVariantState(findVariant(getSelectedOptions()));
      });
    });
  });

  document.querySelectorAll('.option-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const r = this.querySelector('input[type="radio"]');
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });

  (function () {
    const checked = document.querySelector('.option-values input[type="radio"]:checked');
    if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
  })();


  /* ─── PRODUCT FORM ─── */
  const productForm  = document.getElementById('productForm');
  const atcFeedback  = document.getElementById('atcFeedback');
  const addToCartBtn = document.getElementById('addToCartBtn');
  const stickyAtcBtn = document.getElementById('stickyAtcBtn');

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addToCartBtn) { addToCartBtn.textContent = 'ADDING...'; addToCartBtn.disabled = true; }
      const id  = variantId ? variantId.value : this.querySelector('[name="id"]').value;
      const qty = parseInt(document.getElementById('qtyInput')?.value || 1);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, quantity: qty }) })
        .then(r => r.json())
        .then(() => {
          if (addToCartBtn) { addToCartBtn.textContent = '\u2713 ADDED TO CART'; addToCartBtn.disabled = false; }
          if (atcFeedback) { atcFeedback.textContent = 'Item added to your cart.'; atcFeedback.className = 'atc-feedback success'; atcFeedback.style.display = 'block'; }
          fetchCart(); setTimeout(openCart, 400);
          setTimeout(() => { if (addToCartBtn) addToCartBtn.textContent = 'ADD TO CART'; if (atcFeedback) atcFeedback.style.display = 'none'; }, 3000);
        })
        .catch(() => {
          if (addToCartBtn) { addToCartBtn.textContent = 'ADD TO CART'; addToCartBtn.disabled = false; }
          if (atcFeedback) { atcFeedback.textContent = 'Something went wrong. Please try again.'; atcFeedback.className = 'atc-feedback error'; atcFeedback.style.display = 'block'; }
        });
    });
  }
  stickyAtcBtn?.addEventListener('click', () => addToCartBtn?.click());


  /* ─── QUANTITY CONTROLS ─── */
  const qtyInput = document.getElementById('qtyInput');
  document.getElementById('qtyMinus')?.addEventListener('click', () => { if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1; });
  document.getElementById('qtyPlus')?.addEventListener('click',  () => { if (qtyInput) qtyInput.value = parseInt(qtyInput.value) + 1; });


  /* ─── ACCORDION ─── */
  [['descToggle','descBody'],['shippingToggle','shippingBody']].forEach(([tId, bId]) => {
    const toggle = document.getElementById(tId), body = document.getElementById(bId), arrow = toggle?.querySelector('.desc-arrow');
    if (!toggle || !body) return;
    if (tId === 'descToggle') { body.classList.add('open'); arrow?.classList.add('open'); }
    toggle.addEventListener('click', () => { body.classList.toggle('open'); arrow?.classList.toggle('open'); });
  });


  /* ─── STICKY ATC ─── */
  const stickyAtc = document.getElementById('stickyAtc');
  if (stickyAtc && addToCartBtn) {
    new IntersectionObserver(entries => { stickyAtc.style.display = entries[0].isIntersecting ? 'none' : 'flex'; }, { threshold: 0 }).observe(addToCartBtn);
  }


  /* ─── QUOTE FORM ─── */
  const sendQuoteBtn  = document.getElementById('sendQuoteBtn');
  const quoteFeedback = document.getElementById('quoteFeedback');
  if (sendQuoteBtn) {
    sendQuoteBtn.addEventListener('click', function () {
      const name    = document.getElementById('quoteName')?.value?.trim();
      const email   = document.getElementById('quoteEmail')?.value?.trim();
      if (!name || !email) {
        if (quoteFeedback) { quoteFeedback.textContent = 'Please enter your name and email.'; quoteFeedback.className = 'quote-feedback atc-feedback error'; quoteFeedback.style.display = 'block'; }
        return;
      }
      const size    = document.getElementById('quoteSize')?.value || '';
      const message = document.getElementById('quoteMessage')?.value || '';
      const title   = document.title.replace(' | OBJEXYZ','');
      window.location.href = `mailto:info@objexyz.com?subject=${encodeURIComponent('Quote Request: '+title)}&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\nProduct: ${title}\nSize/Qty: ${size}\n\n${message}`)}`;
      if (quoteFeedback) { quoteFeedback.textContent = "Opening your email client \u2014 we'll respond within 24 hours."; quoteFeedback.className = 'quote-feedback atc-feedback success'; quoteFeedback.style.display = 'block'; }
    });
  }

});
